/* Product card metal swatches + favourites (snippets/metal-cards.liquid). */
(function () {
  if (window.MetalCards) return;
  var FAV_KEY = 'mc-favorites';

  function readFavs() { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; } }
  function writeFavs(list) { try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {} }
  function sync(scope) {
    var favs = readFavs();
    (scope || document).querySelectorAll('[data-mc-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', favs.indexOf(b.dataset.handle) > -1 ? 'true' : 'false');
    });
  }

  function apply(btn) {
    var card = btn.closest('[data-mc-card]');
    if (!card) return;
    card.querySelectorAll('[data-mc-swatch]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var link = card.querySelector('[data-mc-link]');
    if (link && btn.dataset.url) link.href = btn.dataset.url;
    var title = card.querySelector('[data-mc-title]');
    if (title && btn.dataset.title) title.textContent = btn.dataset.title;
    var price = card.querySelector('[data-mc-price]');
    if (price && btn.dataset.price) price.innerHTML = btn.dataset.price;
    var metal = card.querySelector('[data-mc-metal]');
    if (metal) metal.textContent = btn.dataset.metal || '';
    var i1 = card.querySelector('.mc-card__img1');
    if (i1 && btn.dataset.img1) { i1.removeAttribute('srcset'); i1.src = btn.dataset.img1; }
    var i2 = card.querySelector('.mc-card__img2');
    if (i2) {
      if (btn.dataset.img2) { i2.removeAttribute('srcset'); i2.src = btn.dataset.img2; i2.style.display = ''; }
      else i2.style.display = 'none';
    }
    var fav = card.querySelector('[data-mc-fav]');
    if (fav && btn.dataset.handle) { fav.dataset.handle = btn.dataset.handle; sync(card); }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-mc-swatch]');
    if (sw) { e.preventDefault(); apply(sw); return; }
    var fav = e.target.closest('[data-mc-fav]');
    if (fav) {
      e.preventDefault();
      var favs = readFavs(), h = fav.dataset.handle, i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      writeFavs(favs);
      sync();
    }
  });
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-mc-swatch]');
    if (!sw || !window.matchMedia('(hover: hover)').matches) return;
    var wrap = sw.closest('[data-mc-hover-switch]');
    if (wrap) apply(sw);
  });
  document.addEventListener('DOMContentLoaded', function () { sync(); });
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });

  window.MetalCards = { sync: sync, apply: apply };
})();
